import { Button } from '@material-tailwind/react';
import { ReactComponent as LeftIcon } from '@assets/images/left_icon.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/Success.svg';
import { ReactComponent as InfoErrorIcon } from '@assets/icons/info_error_icon.svg';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useOrgStore, useSellerStore } from '@stores';
import { getAssetSpecificContent } from '@utils';
import { AssetTypesEnum } from '@types';

export const VehiclePhotos = ({
  setStep
}: {
  setStep: (step: string) => void;
}) => {
  const [primaryColor, setPrimaryColor] = useState('#002861');
  const { organisation } = useOrgStore();
  const {
    vehicleFront,
    vehicleDriver,
    vehiclePassenger,
    vehicleBack,
    assetType,
    documents
  } = useSellerStore();
  const newAssetType =
    assetType === AssetTypesEnum.MARINE_WITH_TRAILER
      ? AssetTypesEnum.TRAILER
      : assetType;

  useEffect(() => {
    if (organisation.primaryColour !== '') {
      setPrimaryColor('#' + organisation.primaryColour);
    }
  }, []);

  return (
    <div className="py-4 mx-auto w-full overflow-hidden relative mb-4">
      <div className="flex flex-col gap-4">
        <p className="text-gray-700">
          <span className="font-semibold">
            Please ensure that all photos are real-time captures of the actual{' '}
            {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}.
          </span>
          <span>
            {' '}
            Images of printed photos or screenshots will be detected and
            rejected.
          </span>
        </p>
      </div>
      {/* Vehicle Front */}
      <Button
        onClick={() => setStep('vehicle-front')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg mt-6',
          !vehicleFront.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(newAssetType as AssetTypesEnum).title}{' '}
            Front
          </p>
          {vehicleFront.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!vehicleFront.isDone && documents?.ASSET_FRONT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Passenger Side */}
      <Button
        onClick={() => setStep('vehicle-passenger')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !vehiclePassenger.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {
              getAssetSpecificContent(newAssetType as AssetTypesEnum).sides
                .passenger
            }
          </p>
          {vehiclePassenger.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!vehiclePassenger.isDone && documents?.ASSET_LEFT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Vehicle Back */}
      <Button
        onClick={() => setStep('vehicle-back')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !vehicleBack.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(newAssetType as AssetTypesEnum).title} Back
          </p>
          {vehicleBack.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!vehicleBack.isDone && documents?.ASSET_BACK?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Driver's Side */}
      <Button
        onClick={() => setStep('vehicle-driver')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !vehicleDriver.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {
              getAssetSpecificContent(newAssetType as AssetTypesEnum).sides
                .driver
            }
          </p>
          {vehicleDriver.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!vehicleDriver.isDone && documents?.ASSET_RIGHT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>
    </div>
  );
};

